let token: string | null = null;

export const tokenService = {
  getToken: () => token,
  setToken: (newToken: string) => {
    token = newToken;
  },
  clearToken: () => {
    token = null;
  },
  hasToken: () => token !== null,
};
